import { getLocaleImg } from '~/utils';
import CustomLoginBanner from '~/assets/suite-images/banner/platform_custom_login_banner.png';

export const getLoginBanner = () => {
    return getLocaleImg('account_default_banner');
};

export const getCustomLoginBanner = () => {
    return CustomLoginBanner;
};
